<template>
  <div id='sordid-history'>
    <h3>Duolingo: 2024-now</h3>
    <h4 class='labor'>Math</h4>
    <p class='deets'>
      Working to improve material discovery and on-demand features. Previously, developed content pipeline for
      in-lesson help: multi-step walkthrough feature when learners get stuck.
    </p>
    <h4 class='labor'>Video Call Models</h4>
    <p class='deets'>
      Evaluated and improved use of LLMs in video call. Mix of prompt optimization, cost optimization, and
      iterating on mid-call logic. Led mixed team of eng, learning scientist, and AI researchers.
    </p>
    <h4 class='labor'>Bookshelf</h4>
    <p class='deets'>
      Generated long(er)-form stories to help learners practice reading and retention. Designed and built the serving
      architecture to deploy to learners. Rolled to English, French, Spanish, and German before project cancellation :(
    </p>
    <h3>Google: 2017-2024</h3>
    <h4 class='labor'>Maps</h4>
    <p class='deets'>
      Categorized businesses within Google Maps. Mostly worked on ML model development, in particular building GAMs
      for multi-class classification and developing RAG pipelines. Coordinated heuristic-driven and manual cleanups of
      sensitive businesses (e.g. healthcare and political entities). TL.
    </p>
    <h4 class='labor'>Cloud Code for IntelliJ</h4>
    <p class='deets'>
      Built <strike>open source</strike> plugins for K8s and GCP in the IDE. Most of my work revolved around the
      cluster management workflow, IntelliJ UI (please don't ask me to write more Swing), testing, and dependency
      management.
    </p>
    <h4 class='labor'>Supply Chain</h4>
    <p class='deets'>
      Tracked assets in Google datacenters. Developed pipelines of Map-Reduce jobs to collect records of
      which parts are reporting from datacenters, then reconciled them with financial records. Over time became a
      hybrid project management role, working closely with accounting and legal teams to ensure SOX compliance.
    </p>
    <h3>Amazon: 2015-2016</h3>
    <h4 class='labor'>AWS Payments</h4>
    <p class='deets'>
      Payment instrument management and payment processing for AWS accounts. Developed customer service tools to
      execute one-off transactions and split payments for assisting customers with particular payment requirements.
    </p>
    <h4 class='labor'>Internship 2014: Supply Chain Simulation</h4>
    <p class='deets'>
      Added forecasting parameters and print-on-demand modeling to warehouse simulations.
    </p>
    <h3>Tech stuff</h3>
    <h4 class='labor'>Languages</h4>
    <p class='deets'>
      Primary languages: Kotlin, Java, C++, Python
    </p>
    <p class='deets'>
      Others I actually like: Ruby, Haskell, SML/NJ, JS
    </p>
    <h4 class='labor'>Cloud experience</h4>
    <p class='deets'>AWS + GCP</p>
    <h3>Hobbies</h3>
    <br>
    <p class='deets'>
      Baking (RIP my sourdough starter), reading (mostly spec fic), math, climbing (primarily bouldering), soccer,
      running, video games.
    </p>
    <br>
    <p class='deets'>
      I'm also interested in education. My dad was a teacher, and I've previously taught both math (to the SC ARML
      team) and CS to high schoolers (<a href="https://www.microsoft.com/en-us/teals">TEALS</a>).
    </p>
  </div>
</template>

<script>

export default {
  name: 'ResumePage',
  components: {
  },
}
</script>

<style scoped>
div#sordid-history {
  display: flex;
  align-items: left;
  flex-wrap: wrap;
  flex-flow: column;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25rem;
  max-width: 90ch;
}

h3 {
  text-align: left;
}

h4.labor {
  color: dimgray;
  margin-top: 1.5rem;
  text-align: left;
}

p.deets {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  color: dimgray;
  text-align: left;
}
</style>
